import styled from 'styled-components';

export interface InfoLabelStyledProps {
  nowrap?: boolean;
}

export const InfoLabel = styled.div<InfoLabelStyledProps>`
  color: #999;
  margin-bottom: 2px;
  ${props => props.nowrap && 'white-space: nowrap;'}
`;
